import { useBrowser } from '@awardit/react-use-browser';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

var useBreadcrumbLinks = (storeInfoContext, props) => {
  var _location$state;

  var browser = useBrowser();

  var _useContext = useContext(storeInfoContext),
      categories = _useContext.categories;

  var location = useLocation();
  var links = [];

  if (browser && (_location$state = location.state) != null && _location$state.breadcrumbLinks) {
    // If rendering in the browser and there are breadcrumb-links
    // provided in state, use them.
    return location.state.breadcrumbLinks;
  } // If no breadcrumb-links where provided in location.state,
  // use pathname to find breadcrumbs.


  var pathnameParts = location.pathname.slice(1).split("/");

  var _loop = function _loop(i) {
    var category = categories.find(c => c.url === `/${pathnameParts[i]}` && c.name !== (props == null ? void 0 : props.current));

    if (category) {
      links.push({
        title: category.name,
        pathname: category.url,
        hint: {
          name: category.name
        }
      });

      if (category.children.length > 0 && i < pathnameParts.length - 1) {
        var subcategory = category.children.find(c => c.url === `/${pathnameParts[i]}/${pathnameParts[i + 1]}` && c.name !== (props == null ? void 0 : props.current));

        if (subcategory) {
          links.push({
            title: subcategory.name,
            pathname: subcategory.url,
            hint: {
              name: subcategory.name
            }
          });
        }
      }
    }
  };

  for (var i = 0; i < pathnameParts.length; i++) {
    _loop(i);
  }

  if (links.length === 0 && props != null && props.fallbackCategories && props.fallbackCategories.length > 0) {
    // If no links found to be used and fallbackcategories are provided,
    // try to find a proper fallback to use.
    // The rules are that the first category in the list with
    // children shall be used, otherwise just the first in the list.
    var longest = props.fallbackCategories.reduce((a, c) => {
      if (!a) {
        return c;
      }

      if (a.children.length > 0) {
        return a;
      }

      if (c.children.length > 0) {
        return c;
      }

      return a;
    }, null);

    if (longest) {
      links.push({
        title: longest.name,
        pathname: longest.url,
        hint: {
          name: longest.name
        }
      });

      if (longest.children.length > 0) {
        // Same goes for picking the child category, the first one is picked.
        links.push({
          title: longest.children[0].name,
          pathname: longest.children[0].url,
          hint: {
            name: longest.children[0].name
          }
        });
      }
    }
  }

  return links;
};

export { useBreadcrumbLinks };
//# sourceMappingURL=use-breadcrumb-links.js.map
